var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":_vm.$perHelper('roles:create')},on:{"addEvent":function($event){return _vm.$router.push({ name: 'addRole' })}}},[_vm._v(" "+_vm._s(_vm.$t("roles.roles"))+" ")]),_c('main-table',{attrs:{"fields":_vm.fields,"list_url":'merchant/roles'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }